import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BookingModule } from './booking/booking.module';

import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth.guard';
import { NoAuthGuard } from './services/no-auth.guard';

import { reducers } from './store/reducers';
import { ConfirmationEffect } from './store/effects/confirmation.effect';
import { BookingEffect } from './store/effects/booking.effect';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdminModule } from './admin/admin.module';
import { AdminEffect } from './store/effects/admin.effect';
import { ConfirmationModule } from './confirmation/confirmation.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    BookingModule,
    ConfirmationModule,
    AdminModule,
    HttpClientModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([ConfirmationEffect, BookingEffect, AdminEffect]),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features

    RouterModule.forRoot([
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '/page-not-found',
        pathMatch: 'full'
      }
    ])
  ],
  providers: [AuthService, AuthGuard, NoAuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/app.module.ts